// Unsaved sketches live in IndexedDB on the phone/iPad (one per job, or per sketch being re-edited)
// so a closed tab, a dead battery or a lost signal never costs anyone their drawing.
const DB = 'onsite-drafts';
const STORE = 'drafts';
const MAX_AGE = 14 * 24 * 3600 * 1000;

function open() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB, 1);
    req.onupgradeneeded = () => req.result.createObjectStore(STORE, { keyPath: 'key' });
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function run(mode, fn) {
  const db = await open();
  return new Promise((resolve, reject) => {
    const t = db.transaction(STORE, mode);
    const r = fn(t.objectStore(STORE));
    t.oncomplete = () => { db.close(); resolve(r?.result); };
    t.onerror = () => { db.close(); reject(t.error); };
  });
}

export const draftKey = (jobId, editSkid) => `${jobId}:${editSkid || 'new'}`;

export async function loadDraft(key) {
  try {
    const d = await run('readonly', (s) => s.get(key));
    if (!d) return null;
    if (Date.now() - d.savedAt > MAX_AGE) { await deleteDraft(key); return null; }
    return d;
  } catch (_) { return null; }
}
export const saveDraft = (draft) => run('readwrite', (s) => s.put({ ...draft, savedAt: Date.now() })).catch(() => {});
export const deleteDraft = (key) => run('readwrite', (s) => s.delete(key)).catch(() => {});
